import React from "react";
import Tooltip from "@mui/material/Tooltip";

const MuiTooltipWrapper = ({ title, placement = 'bottom', children,...props }) => {
  return (
    <Tooltip title={title} placement={placement} arrow {...props}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default MuiTooltipWrapper;
